<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile"  @pressEnter="handleQuery":placeholder="$t('通用.输入.请输入')+$t('用户.手机号')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.邮箱')" prop="email">
                <a-input v-model="queryParam.email" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.邮箱')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.性别')" prop="sex">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.性别')" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SexEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.是否申请')" prop="appRole">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.是否申请')" style="width: 100%" v-model="queryParam.appRole" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.是否客服')" prop="loginRole">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.是否客服')" style="width: 100%" v-model="queryParam.loginRole" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户状态')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.StatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="客服分组" prop="brandId">
                <a-select placeholder="请选择客服分组" style="width: 100%"
                          v-model="queryParam.remark" allowClear>
                  <a-select-option v-for="(item, index) in this.brandList" :value="item.id" :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户等级')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户等级')" v-model="queryParam.levelId" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
<!--        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>-->
<!--        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>-->
        <span slot="status" slot-scope="text, record">
          <custom-dict-tag :options="customDict.StatusEnum" :value="record.status"/>
        </span>
        <span slot="remark" slot-scope="text, record">
             {{ getBrandNameById(record.remark) }}
          </span>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
        </template>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- <span slot="loginRole" slot-scope="text, record">
          <a-switch @change="(checked) => onRoleChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.loginRole"/>
        </span> -->
        <span slot="appRole" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.appRole"/>
        </span>

        <span slot="appRole" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.appRole"/>
        </span>


        <span slot="service" slot-scope="text, record">
           <a-switch @change="(checked) => onRoleChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.service"/>
        </span>




        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="handleUpdate(record, undefined)">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a style="margin-left: 8px" @click="handleOpenMerchantModal(record)">
            <a-icon type="shop"/>{{ $t('用户.绑定商户') }}
          </a>
          <a style="margin-left: 8px" @click="handleOpenErpModal(record)">
            <a-icon type="link"/>{{ $t('绑定业务人员') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 绑定商户弹窗 -->
      <a-modal
        :visible="merchantModalVisible"
        :title="$t('用户.绑定商户')"
        width="760px"
        @cancel="merchantModalVisible = false"
      >
        <a-spin :spinning="merchantModalLoading">
          <a-descriptions :column="2" size="small">
            <a-descriptions-item :label="$t('用户.昵称')">
              {{ currentKf.nickName }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('用户.手机号')">
              {{ currentKf.mobile }}
            </a-descriptions-item>
          </a-descriptions>
          <a-divider style="margin: 12px 0"/>
          <!-- 未绑定商户(多选绑定) -->
          <div style="margin-bottom: 12px">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <a-input v-model="unbindSearch" allow-clear
                       :placeholder="$t('通用.输入.请输入')+$t('用户.商户')"
                       style="width: 240px"/>
              <a-button type="primary" :loading="merchantSubmitting"
                        :disabled="!selectedUnbindMerchantIds.length"
                        @click="handleBatchBind">
                {{ $t('用户.绑定选中') }}（{{ selectedUnbindMerchantIds.length }}）
              </a-button>
            </div>
            <a-table
              :columns="unbindMerchantColumns"
              :data-source="filteredUnbindMerchants"
              size="small"
              row-key="merchantId"
              :pagination="{ pageSize: 10, showSizeChanger: true, showTotal: total => `共 ${total} 条` }"
              :row-selection="{ selectedRowKeys: selectedUnbindMerchantIds, onChange: onUnbindSelectChange }"
            >
              <template slot="title">
                <span style="font-weight: 600">{{ $t('用户.未绑定商户') }}</span>
              </template>
            </a-table>
          </div>
          <!-- 已绑定商户 -->
          <a-table
            :columns="boundMerchantColumns"
            :data-source="boundMerchants"
            size="small"
            row-key="merchantId"
            :pagination="{ pageSize: 10, showSizeChanger: true, showTotal: total => `共 ${total} 条` }"
          >
            <template slot="title">
              <span style="font-weight: 600">{{ $t('用户.已绑定商户') }}</span>
            </template>
            <template slot="boundOperation" slot-scope="text, record">
              <a @click="handleUnbindMerchant(record)">{{ $t('用户.解绑') }}</a>
            </template>
          </a-table>
        </a-spin>
      </a-modal>
      <!-- 绑定ERP业务人员弹窗 -->
      <a-modal
        :visible="erpModalVisible"
        :title="$t('用户.绑定ERP业务人员')"
        width="760px"
        @cancel="erpModalVisible = false"
      >
        <a-spin :spinning="erpModalLoading">
          <a-descriptions :column="2" size="small">
            <a-descriptions-item :label="$t('用户.昵称')">
              {{ currentKf.nickName }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('用户.手机号')">
              {{ currentKf.mobile }}
            </a-descriptions-item>
          </a-descriptions>
          <a-divider style="margin: 12px 0"/>
          <!-- 未绑定业务成员(多选绑定) -->
          <div style="margin-bottom: 12px">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <a-input v-model="erpSearch" allow-clear @pressEnter="handleErpSearch"
                       :placeholder="$t('通用.输入.请输入')+$t('用户.业务成员名称')"
                       style="width: 240px"/>
              <a-button type="primary" :loading="erpSubmitting"
                        :disabled="!selectedErpIds.length"
                        @click="handleErpBatchBind">
                {{ $t('用户.绑定选中') }}（{{ selectedErpIds.length }}）
              </a-button>
            </div>
            <a-table
              :columns="erpUnboundColumns"
              :data-source="erpUnboundList"
              size="small"
              row-key="id"
              :loading="erpUnboundLoading"
              :pagination="erpUnboundPagination"
              :row-selection="{ selectedRowKeys: selectedErpIds, onChange: onErpSelectChange }"
              @change="onErpUnboundTableChange"
            >
              <template slot="title">
                <span style="font-weight: 600">{{ $t('用户.未绑定业务成员') }}</span>
              </template>
            </a-table>
          </div>
          <!-- 已绑定业务成员 -->
          <a-table
            :columns="erpBoundColumns"
            :data-source="erpBoundList"
            size="small"
            row-key="id"
            :loading="erpBoundLoading"
            :pagination="erpBoundPagination"
            @change="onErpBoundTableChange"
          >
            <template slot="title">
              <span style="font-weight: 600">{{ $t('用户.已绑定业务成员') }}</span>
            </template>
            <template slot="erpBoundOperation" slot-scope="text, record">
              <a @click="handleErpUnbind(record)">{{ $t('用户.解绑') }}</a>
            </template>
          </a-table>
        </a-spin>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageKf,listUser, delUser,updateRole,updSysUserByService } from '@/api/biz/user'
import { merchantKfPage, bindMerchantKf, unbindMerchantKf } from '@/api/biz/userMerchantKf'
import { erpUnboundPage, erpBoundPage, erpBind, erpUnbind } from '@/api/biz/erpContact'
import CreateForm from './modules/CreateForm'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import { tableMixin } from '@/store/table-mixin'
import {listLevel} from "@/api/user/level";
import events from "@/components/MultiTab/events";
import bus from "@/utils/bus";
import {updateShopRecommend} from "@/api/shop/shop";
import {listGrouping} from "@/api/kf/grouping";

export default {
  name: 'User',
  components: {
    CreateForm,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      brandList: [],
      levelList: [],

      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 绑定商户弹窗
      merchantModalVisible: false,
      merchantModalLoading: false,
      merchantSubmitting: false,
      currentKf: {},
      boundMerchants: [],
      unbindMerchants: [],
      unbindSearch: '',
      selectedUnbindMerchantIds: [],
      unbindMerchantColumns: [
        {
          title: this.$t('用户.商户昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          align: 'center'
        }
      ],
      boundMerchantColumns: [
        {
          title: this.$t('用户.商户昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('用户.绑定时间'),
          dataIndex: 'bindTime',
          align: 'center',
          customRender: (text) => (text ? this.parseTime(text) : '')
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'boundOperation' },
          align: 'center'
        }
      ],
      // 绑定ERP业务人员弹窗
      erpModalVisible: false,
      erpModalLoading: false,
      erpSubmitting: false,
      erpSearch: '',
      erpUnboundList: [],
      erpBoundList: [],
      selectedErpIds: [],
      erpUnboundLoading: false,
      erpBoundLoading: false,
      erpUnboundPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: total => `共 ${total} 条` },
      erpBoundPagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: total => `共 ${total} 条` },
      erpUnboundColumns: [
        {
          title: this.$t('用户.业务成员名称'),
          dataIndex: 'bill_name',
          align: 'center'
        },
        {
          title: this.$t('用户.电话'),
          dataIndex: 'phone',
          align: 'center'
        }
      ],
      erpBoundColumns: [
        {
          title: this.$t('用户.业务成员名称'),
          dataIndex: 'bill_name',
          align: 'center'
        },
        {
          title: this.$t('用户.电话'),
          dataIndex: 'phone',
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'erpBoundOperation' },
          align: 'center'
        }
      ],
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        remark:undefined,
        nickName: null,
        sex: undefined,
        loginRole:undefined,
        appRole:undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户.手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        /*{
          title: this.$t('用户.邮箱'),
          dataIndex: 'email',
          align: 'center'
        },*/
        {
          title: this.$t('用户.昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        {
          title: "客服分组",
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('用户.真实姓名'),
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.微信'),
          dataIndex: 'weChat',
          ellipsis: true,
          align: 'center'
        },
        {
          title: "qq",
          dataIndex: 'qq',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.用户等级'),
          dataIndex: 'levelName',
          align: 'center'
        },*/
        {
          title: this.$t('用户.性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          align: 'center'
        },
        /*{
          title: this.$t('用户.是否客服'),
          dataIndex: 'loginRole',
          scopedSlots: { customRender: 'loginRole' },
          align: 'center'
        },*/
       /* {
          title: this.$t('用户.是否申请'),
          dataIndex: 'appRole',
          scopedSlots: { customRender: 'appRole' },
          align: 'center'
        },*/
        /*{
          title:  this.$t('用户.生日'),
          dataIndex: 'birthday',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('用户.用户状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.注册时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '默认客服',
          dataIndex: 'service',
          scopedSlots: { customRender: 'service' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '19%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getLevelList();
    this.getList()
    this.getBrandList();
    /**编辑页面接收到更新的数据 */
    bus.$on('updateShopList',()=>{
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict']),
    // 未绑定商户按昵称/手机号过滤
    filteredUnbindMerchants() {
      const keyword = (this.unbindSearch || '').trim().toLowerCase()
      if (!keyword) return this.unbindMerchants
      return this.unbindMerchants.filter(item =>
        (item.nickName || '').toLowerCase().indexOf(keyword) >= 0
        || (item.mobile || '').toLowerCase().indexOf(keyword) >= 0
      )
    }
  },
  watch: {
  },
  methods: {

    /** 打开绑定商户弹窗 */
    handleOpenMerchantModal(record) {
      this.currentKf = record
      this.selectedUnbindMerchantIds = []
      this.unbindSearch = ''
      this.merchantModalVisible = true
      this.merchantModalLoading = true
      // 查询当前客服已绑定的商户
      merchantKfPage({ kfId: record.id, pageNum: 1, pageSize: 100 }).then(response => {
        this.boundMerchants = (response.data && response.data.records) ? response.data.records : []
      })
      // 查询未绑定客服的商户
      merchantKfPage({ pageNum: 1, pageSize: 100 }).then(response => {
        const records = (response.data && response.data.records) ? response.data.records : []
        this.unbindMerchants = records.filter(item => !item.bound)
      }).finally(() => {
        this.merchantModalLoading = false
      })
    },
    /** 多选变更 */
    onUnbindSelectChange(selectedRowKeys) {
      this.selectedUnbindMerchantIds = selectedRowKeys
    },
    /** 批量绑定商户 */
    handleBatchBind() {
      const ids = this.selectedUnbindMerchantIds
      if (!ids.length) {
        this.$message.warning(this.$t('用户.请选择商户'))
        return
      }
      this.merchantSubmitting = true
      const kfId = this.currentKf.id
      Promise.all(ids.map(merchantId => bindMerchantKf({ merchantId, kfId }))).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.selectedUnbindMerchantIds = []
        this.refreshMerchantModal()
      }).catch(() => {
        this.$message.error(this.$t('通用.文本.修改失败'))
      }).finally(() => {
        this.merchantSubmitting = false
      })
    },
    /** 解绑商户 */
    handleUnbindMerchant(record) {
      const that = this
      this.$confirm({
        title: this.$t('用户.解绑'),
        content: this.$t('用户.确认解绑商户'),
        okType: 'danger',
        onOk () {
          that.merchantSubmitting = true
          return unbindMerchantKf({ merchantId: record.merchantId }).then(() => {
            that.$message.success(that.$t('通用.文本.修改成功'))
            that.refreshMerchantModal()
          }).catch(() => {
            that.$message.error(that.$t('通用.文本.修改失败'))
          }).finally(() => {
            that.merchantSubmitting = false
          })
        }
      })
    },
    /** 刷新弹窗内列表 */
    refreshMerchantModal() {
      const that = this
      merchantKfPage({ kfId: this.currentKf.id, pageNum: 1, pageSize: 100 }).then(response => {
        that.boundMerchants = (response.data && response.data.records) ? response.data.records : []
      })
      merchantKfPage({ pageNum: 1, pageSize: 100 }).then(response => {
        const records = (response.data && response.data.records) ? response.data.records : []
        that.unbindMerchants = records.filter(item => !item.bound)
      })
    },
    /** 打开绑定ERP业务人员弹窗 */
    handleOpenErpModal(record) {
      this.currentKf = record
      this.selectedErpIds = []
      this.erpSearch = ''
      this.erpUnboundPagination.current = 1
      this.erpBoundPagination.current = 1
      this.erpModalVisible = true
      this.loadErpUnbound()
      this.loadErpBound()
    },
    /** ERP搜索 */
    handleErpSearch() {
      this.erpUnboundPagination.current = 1
      this.loadErpUnbound()
    },
    /** 加载未绑定业务成员 */
    loadErpUnbound() {
      this.erpUnboundLoading = true
      const { current, pageSize } = this.erpUnboundPagination
      erpUnboundPage({ userId: this.currentKf.id, billName: this.erpSearch, pageNum: current, pageSize }).then(response => {
        this.erpUnboundList = (response.data && response.data.records) ? response.data.records : []
        this.erpUnboundPagination.total = response.data ? response.data.total : 0
      }).finally(() => {
        this.erpUnboundLoading = false
      })
    },
    /** 加载已绑定业务成员 */
    loadErpBound() {
      this.erpBoundLoading = true
      const { current, pageSize } = this.erpBoundPagination
      erpBoundPage({ userId: this.currentKf.id, pageNum: current, pageSize }).then(response => {
        this.erpBoundList = (response.data && response.data.records) ? response.data.records : []
        this.erpBoundPagination.total = response.data ? response.data.total : 0
      }).finally(() => {
        this.erpBoundLoading = false
      })
    },
    /** 未绑定列表翻页 */
    onErpUnboundTableChange(pagination) {
      this.erpUnboundPagination.current = pagination.current
      this.erpUnboundPagination.pageSize = pagination.pageSize
      this.loadErpUnbound()
    },
    /** 已绑定列表翻页 */
    onErpBoundTableChange(pagination) {
      this.erpBoundPagination.current = pagination.current
      this.erpBoundPagination.pageSize = pagination.pageSize
      this.loadErpBound()
    },
    /** ERP多选变更 */
    onErpSelectChange(selectedRowKeys) {
      this.selectedErpIds = selectedRowKeys
    },
    /** 批量绑定ERP业务成员 */
    handleErpBatchBind() {
      const ids = this.selectedErpIds
      if (!ids.length) {
        this.$message.warning(this.$t('用户.请选择业务成员'))
        return
      }
      this.erpSubmitting = true
      const userId = this.currentKf.id
      Promise.all(ids.map(contactId => erpBind({ contactId, userId }))).then(() => {
        this.$message.success(this.$t('通用.文本.修改成功'))
        this.selectedErpIds = []
        this.loadErpUnbound()
        this.loadErpBound()
      }).catch(() => {
        this.$message.error(this.$t('通用.文本.修改失败'))
      }).finally(() => {
        this.erpSubmitting = false
      })
    },
    /** 解绑ERP业务成员 */
    handleErpUnbind(record) {
      const that = this
      this.$confirm({
        title: this.$t('用户.解绑'),
        content: this.$t('用户.确认解绑业务成员'),
        okType: 'danger',
        onOk () {
          return erpUnbind({ contactId: record.id, userId: that.currentKf.id }).then(() => {
            that.$message.success(that.$t('通用.文本.修改成功'))
            that.loadErpUnbound()
            that.loadErpBound()
          }).catch(() => {
            that.$message.error(that.$t('通用.文本.修改失败'))
          })
        }
      })
    },

     onRoleChange(checked, record) {
      let data = {id: record.id, service: checked?1:0}
      record.loginRole = checked
      console.log(data,'是否为默认客服',record);
      if(record.service==1){
        this.$message.error('当前为默认客服，请勿修改！');
        return false;
      }

      updSysUserByService(data).then(response => {
        if (response.success) {
          this.$message.success('默认客服已修改！');
          record.service = checked
          this.getList()
        }
      }).finally(() => {
        this.submitLoading = false
      })
      
    },

    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageKf(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getBrandNameById(id) {debugger
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.title
      } else {
        return "";
      }
    },
    // onRoleChange(checked, record) {
    //   let data = {id: record.id, shopRecommend: checked}
    //   updateRole(data).then(response => {
    //     if (response.success) {
    //       this.$message.success(
    //         this.$t('通用.文本.修改成功'),
    //         3
    //       );
    //       this.$emit('ok')
    //       record.loginRole = checked
    //     }
    //   }).finally(() => {
    //     this.submitLoading = false
    //   })
    // },
    getLevelList () {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {debugger
      this.$router.push({
        path: 'userdetailkf',
        query:
          {
            id: row.id
          }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        remark: undefined,
        email: undefined,
        nickName: undefined,
        sex: undefined,
        loginRole:undefined,
        appRole:undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getBrandList() {
      listGrouping().then(response => {
        this.brandList = response.data
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('biz/user/export', queryParam, `用户信息_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
